<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name="fade")
      .content.programs(v-if='!loading')
        .grid
          .col-12
            h2.category
              | programs
          .col-12
            .screen(v-if='!loading')
              router-link(:to="{name: 'programs-page', params: {category: 'current', id: featured.uid }}")
                visual(:image="featured.main_image.url" background="cover")
                .captions
                  h1
                    | {{ featured.title }}
                  h2
                    | {{ featured.content.date }}
                  h2
                    | {{ featured.content.start_time }} - {{ featured.content.end_time }}
          .col-4_xs-12.titles
            h2
              | calendar
            datepicker.picker.noselect(
              :config="{ wrap: true, static: true, onChange: update, animate: false, minDate: 'today'}"
              placeholder="select a date"
              v-model="dateSelected"
            )
              p(@click="openCalendar")
                | select a date
              a.input-button.x(title="toggle" data-toggle)
                figure
                  img(src="/static/icons/x_out_white.svg")
          .col-8_xs-12.week#calendarcontainer
            .grid.no-margin
              .col-8
                h2
                  | {{ day }}
              .col-8(v-for="program in week" v-if="week.length > 0")
                router-link.dateTime(
                  :to="{name: 'programs-page', params: {category: category(program.content.category), id: program.uid }}"
                )
                  h3
                    | {{ program.content.title }}
                  h4
                    | {{ program.content.date }}
                  p
                    | {{ program.content.start_time }} - {{ program.content.end_time }}
              .col-8(v-if="week.length === 0")
                h4
                  | No events scheduled for this day.
              .col-8
                .pmargin
              .col-6_xs-12(v-for="item in children")
                .filter
                  .captions-mobile
                    h2.subpage
                      | {{ item.content.title.toLowerCase() }}
                  .screen-small(v-if='!loading')
                    router-link(:to="{name: 'programs-overview', params: {category: category(item.category)}}")
                      visual(:image="item.main_image.url" background="cover")
                    .captions.gradient
                      h2.subpage
                        | {{ item.category.toLowerCase() }}
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'
import Datepicker from 'vue-bulma-datepicker'

export default {
  name: 'program',
  mixins: [DataMixin, ComponentMixin],
  components: {
    Datepicker
  },

  data () {
    return {
      date: new Date(),
      selectDate: false,
      dateSelected: '',
      day: 'next 30 days',
      url: 'https://caamuseum.org/api/programs/day?date='
    }
  },

  created () {
    this.requestData('programs', 'programs')
  },

  methods: {
    category: function (item) {
      const str = item.split("'").join('-')
      const sanatize = (str.split(' ').join('-').toLowerCase()).split('!').join('')
      return sanatize.split(',').join('').toLowerCase()
    },

    openCalendar: function () {
      document.getElementsByClassName('flatpickr-input')[0].focus()
    },

    closeCalendar: function () {
      document.getElementsByClassName('flatpickr-input')[0].blur()
    },

    update: function () {
      this.getData()
    },

    getData: function () {
      const url = this.url + this.dateSelected
      this.loading = true
      this.get(url, response => {
        this.loading = false
        this.week.splice(0, this.week.length)
        this.day = response.data.day
        for (var i = 0; i < response.data.programs.length; i++) {
          this.week.push(response.data.programs[i])
        }
        // const sT = document.getElementById('calendarcontainer')
        // sT.scrollIntoView()
        // window.scrollBy(0, -450)
      })
    }
  },

  computed: {
    data: function () {
      return this.loadedData.programs
    },

    content: function () {
      return this.data.content
    },

    featured: function () {
      return this.data.featured
    },

    past: function () {
      return this.data.past
    },

    edu: function () {
      return this.data.education
    },

    week: function () {
      return this.data.week
    },

    children: function () {
      return this.data.children
    },

    key: function () {
      return 'programs'
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/main'
  .programs
    .pmargin
      height: 4rem
    .titles
      margin-top: 0
    h2
      letter-spacing: $kerningTight
      @include respond-to(xs)
        letter-spacing: $kerningTightMobile
    h4
      font-size: 2rem
      margin: 0
      line-height: 150%
      letter-spacing: $kerningh4
    .category
      color: $programs
      margin-bottom: 2rem
    .screen
      height: 76.5vH
      width: 100%
      margin-bottom: 6rem
      @include respond-to(xs)
        height: 52vW
      .vv-image
        width: 100%
        height: 76.5vH
        background-repeat: no-repeat
        background-size: cover
        @include respond-to(xs)
          height: 52vW
      .captions
        width: 100%
        h1
          font-style: normal
    .week
      position: relative
      margin-top: 1.7rem
      h2, h3, h4, a
        padding: 0
        margin: 0
      h3
        font-size: 3rem
        padding-top: 0.4rem
        letter-spacing: -0.19rem
        @include respond-to(xs)
          font-size: 1.5rem
          letter-spacing: -0.06rem
      h4
        font-size: 2rem
        @include respond-to(xs)
          font-size: 1rem
          letter-spacing: -0.06rem
      p
        font-size: 1.8rem
        padding-left: 0
        letter-spacing: 0
        margin: 0
        @include respond-to(xs)
          font-size: 1rem
          letter-spacing: -0.06rem
      a
        &:hover h3
          border-bottom: solid 2px #000
      h3
        display: inline
        border-bottom: solid 2px #FFF
      .dateTime
        h4, p
          margin: 0
        h4
          letter-spacing: -0.1rem
        p
          letter-spacing: -0.05rem
        @include respond-to(xs)
    .filter
      margin: 0
      h2
        margin-bottom: 2rem
      .screen-small
        width: 100%
        height: 0
        padding-bottom: 100%
        @include respond-to(xs)
          padding-bottom: 52vW
      .vv-visual
        margin: 0
        width: 100%
        height: 0
        padding-bottom: 100%
        @include respond-to(xs)
          padding-bottom: 52vW
        .vv-image
          width: 100%
          height: 0
          padding-bottom: 100%
          background-repeat: no-repeat
          background-size: cover
          @include respond-to(xs)
            padding-bottom: 52vW
      .screen-small
        position: relative
        .captions, .captions-mobile
          width: 100%
          height: 40%
          opacity: 1
          color: white
          position: absolute
          bottom: 0
          pointer-events: none
          &.gradient
            background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.75))
          h2
            position: absolute
            bottom: 0
            font-size: 4rem
            padding-left: 3.3rem
            padding-right: 3.3rem
            padding-bottom: 3.3rem
            margin: 0
            letter-spacing: $kerningMidTight
        .captions
          @include respond-to(xs)
            display: none
      .captions-mobile
        display: none
        @include respond-to(xs)
          display: block
    .picker
      p
        font-weight: 700
        color: #f47b1f
        cursor: pointer
        letter-spacing: -0.1rem
      .x
        position: absolute
        cursor: pointer
        left: 21vW
        z-index: 99999999
        top: 79vH
        figure
          img
            width: 3rem
      input
        opacity: 0
        height: 0
        padding: 0
        margin: 0
    .flatpickr-rContainer
      width: 60%
      left: 20%
      top: 21rem
      position: relative
      .flatpickr-weekdays
        width: 100%
        letter-spacing: -0.1rem
      .flatpickr-days, .dayContainer
        width: 100% !important
        min-width: unset
        max-width: unset
        .dayContainer
          flex-direction: row
    .flatpickr-calendar
      border-radius: 0
      box-shadow: none
      position: relative
      top: -5rem !important
      left: 21vW
      width: 71.34vW
      height: 97vH
      background-color: rgba(0,0,0,0.9)
      &.open
        max-height: 97vH
      .flatpickr-innerContainer
        overflow: visible
      .flatpickr-current-month
        text-align: left
        left: 13.8%
        font-size: 4rem
        letter-spacing: -0.23rem
      .flatpickr-month
        height: 86vH
        width: 100%
        position: absolute
        top: 13vH
        color: white
        text-transform: lowercase
        .numInputWrapper
          font-family: inherit
          color: inherit
          margin-left: 2rem
          > *
            font-weight: 700
        .flatpickr-prev-month, .flatpickr-next-month
          position: absolute
          top: 32.5vH
          svg
            fill: #FFF
            width: 3vW
        .flatpickr-next-month
          right: 9vW
        .flatpickr-prev-month
          left: 9vW
      .flatpickr-weekday
        text-transform: lowercase
        color: white
        font-size: 1.7rem
        font-weight: 700
      .flatpickr-day
        box-sizing: unset
        color: white
        font-size: 1.7rem
        font-weight: 700
        flex-basis: 2.5vW
        margin: 1.5vW
        margin-bottom: 1vW
        max-width: 2.5  vW
        height: 2.5vW
        &.selected
          background-color: #68cce8
          border-color: #68cce8
        &.today
          background-color: #f47b1f
          border-color: #f47b1f
      .prevMonthDay, .nextMonthDay
        opacity: 0
        cursor: default
      &.animate.open
        animation: none
        -webkit-animation: none
</style>



// WEBPACK FOOTER //
// Programs.vue?45e3c10f